import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import './GoalEditor.css';

const GOAL_TYPES = [
  { value: 'conversion', label: 'Conversion' },
  { value: 'revenue', label: 'Revenue' },
  { value: 'count', label: 'Count' },
  { value: 'duration', label: 'Duration' },
];

const EVENT_PRESETS = [
  { value: 'page_view', label: 'Page View' },
  { value: 'add_to_cart', label: 'Add to Cart' },
  { value: 'checkout_start', label: 'Checkout Start' },
  { value: 'purchase', label: 'Purchase' },
];

function GoalEditor({ goals, onChange }) {
  const addGoal = () => {
    onChange([
      ...goals,
      { event_name: '', goal_type: 'conversion', is_primary: goals.length === 0 },
    ]);
  };

  const removeGoal = (index) => {
    const updated = goals.filter((_, i) => i !== index);
    if (updated.length > 0 && !updated.some((g) => g.is_primary)) {
      updated[0].is_primary = true;
    }
    onChange(updated);
  };

  const updateGoal = (index, field, value) => {
    const updated = goals.map((g, i) => {
      if (i !== index) return g;
      return { ...g, [field]: value };
    });
    onChange(updated);
  };

  const setPrimary = (index) => {
    const updated = goals.map((g, i) => ({
      ...g,
      is_primary: i === index,
    }));
    onChange(updated);
  };

  return (
    <div className="goal-editor">
      <div className="goal-editor-header">
        <h3>Goals</h3>
        <button type="button" className="exp-btn-secondary" onClick={addGoal}>
          <Plus size={14} />
          Add Goal
        </button>
      </div>

      {goals.length === 0 && (
        <div className="goal-empty">
          <p>No goals defined. Add at least one goal to measure experiment results.</p>
        </div>
      )}

      {goals.map((goal, index) => (
        <div key={index} className="goal-card">
          <div className="goal-card-header">
            <span className="goal-label">Goal {index + 1}</span>
            {goal.is_primary && <span className="goal-primary-badge">Primary</span>}
            <button
              type="button"
              className="goal-remove-btn"
              onClick={() => removeGoal(index)}
              title="Remove goal"
            >
              <Trash2 size={14} />
            </button>
          </div>

          <div className="goal-fields">
            <div className="exp-form-group goal-field-event">
              <label className="exp-form-label">Event Name</label>
              <div className="goal-event-wrapper">
                <input
                  type="text"
                  className="exp-form-input"
                  value={goal.event_name}
                  onChange={(e) => updateGoal(index, 'event_name', e.target.value)}
                  placeholder="e.g. purchase"
                />
                <div className="goal-presets">
                  {EVENT_PRESETS.map((preset) => (
                    <button
                      key={preset.value}
                      type="button"
                      className={`goal-preset-btn ${goal.event_name === preset.value ? 'active' : ''}`}
                      onClick={() => updateGoal(index, 'event_name', preset.value)}
                    >
                      {preset.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="exp-form-group goal-field-type">
              <label className="exp-form-label">Goal Type</label>
              <select
                className="exp-form-input"
                value={goal.goal_type}
                onChange={(e) => updateGoal(index, 'goal_type', e.target.value)}
              >
                {GOAL_TYPES.map((t) => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
              </select>
            </div>

            <div className="exp-form-group goal-field-primary">
              <label className="exp-form-label">Primary</label>
              <button
                type="button"
                className={`goal-primary-toggle ${goal.is_primary ? 'active' : ''}`}
                onClick={() => setPrimary(index)}
              >
                {goal.is_primary ? 'Yes' : 'No'}
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default GoalEditor;
